import { css } from 'lit';
export default css `
  :host {
    display: block;
  }

  .input-contianer {
    position: relative;
  }

  sl-input {
    --sl-input-font-size-medium: 14px;
    --sl-input-font-weight: 400;
    --sl-input-height-medium: 40px;

    --sl-input-letter-spacing: -0.2px;
    --sl-input-color: var(--amityeko-color-gray-1);

    --sl-input-background-color: #ffffff;

    --sl-input-border-width: 1px;
    --sl-input-border-color: var(--amityeko-color-gray-8);
    --sl-input-border-color-hover: var(--amityeko-color-gray-8);
    --sl-input-border-color-focus: var(--amityeko-color-primary-3);
    --sl-input-border-radius-medium: var(--amityeko-radius-small);

    --sl-input-placeholder-color: var(--amityeko-color-gray-6);
    --sl-input-placeholder-color-disabled: var(--amityeko-color-gray-7);
    --sl-input-required-content: none;

    /* This is required to redefine SL behavior (or active:not(hover) will be a default SL color) */
    --sl-focus-ring: 0 0 0 4px var(--amityeko-color-primary-1);
    --sl-focus-ring-width: 4px;
    --sl-input-focus-ring-color: var(--amityeko-color-primary-1);
  }

  sl-input::part(input) {
    padding: 9px 15px 9px 15px;
    line-height: 20px;
    caret-color: var(--amityeko-color-primary-6);
  }

  sl-input.input--with-counter::part(input) {
    padding-right: 60px;
  }

  sl-input.input--with-prefix::part(input) {
    padding-left: 8px;
  }

  sl-input::part(base):hover {
    box-shadow: 0 0 0 4px var(--amityeko-color-primary-1);
  }

  sl-input::part(form-control) {
    display: flex;
    align-items: center;
  }

  sl-input::part(form-control-label) {
    flex: 0 0 auto;
    width: var(--public-label-width, 84px);
  }

  sl-input::part(form-control-input) {
    flex: 1 1 auto;
    width: 100%;
    max-width: var(--amityeko-input-max-width, none);
  }

  sl-input::part(clear-button) {
    width: 17px;
    margin: 0 15px 0 0;
    font-size: 17px;
    color: var(--amityeko-color-gray-6);
  }

  ::slotted([slot='prefix']) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 18px;
    padding-inline-start: 12px;
    --amityeko-icon-size: 16px;
    --amityeko-icon-color: var(--amityeko-color-gray-6);
  }

  .label {
    display: inline-block;
  }

  .suffix {
    padding-right: 15px;
    color: var(--amityeko-color-gray-6);
  }

  .counter {
    position: absolute;
    top: 10px;
    right: var(--private-right-padding);
  }
`;
//# sourceMappingURL=styles.js.map